export const spanOptions: Record<string, string> = {
  ...Object.fromEntries(Array.from({ length: 12 }, (_, i) => [String(i + 1), String(i + 1)])),
  full: 'Full',
}

export const getNumberOfGridClass = (numberOfGrid: number | string = 2) => {
  if (numberOfGrid === 'full') return 'grid-cols-1'
  return `md:grid-cols-${numberOfGrid} grid-cols-1`
}

export const getFieldSpanClass = (span: number | string = 1) => {
  if (span === 'full') return 'col-span-full'
  return `md:col-span-${span}`
}
